import { useMsal } from "@azure/msal-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import ResourcesService from "../Services/ResourcesService";
import ResourceModel from "../Models/ResourceModel";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import ResourceModal from "../Components/ResourceModal";

const ResourcesSettings = () => {
  const { instance } = useMsal();

  const resourcesService = useMemo(
    () => new ResourcesService(instance),
    [instance],
  );

  const [resources, setResources] = useState<ResourceModel[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedResource, setSelectedResource] = useState<ResourceModel>();

  const loadResources = useCallback(async () => {
    try {
      const data = await resourcesService.get();

      setResources(data);
    } catch (error) {
      toast.error("Fout bij het ophalen van de data.");
    }
  }, [resourcesService]);

  useEffect(() => {
    loadResources();
  }, [loadResources]);

  async function afterSave() {
    try {
      setShowModal(false);

      await loadResources();
    } catch (err) {
      toast.error("Fout bij het ophalen van de data.");
    }
  }

  function afterCancel() {
    setShowModal(false);
  }

  let modal = null;
  if (showModal && selectedResource) {
    modal = (
      <ResourceModal
        resource={selectedResource}
        afterSave={() => afterSave()}
        afterCancel={() => afterCancel()}
      />
    );
  }

  return (
    <div className="container-fluid">
      <div className="card mb-3">
        <div className="card-body">
          <form>
            <div className=" row">
              <div className="col-2 form-inline"></div>
            </div>
          </form>
          <div className="row">
            <div className="col">
              <Button
                color="primary"
                onClick={() => {
                  setShowModal(true);
                  setSelectedResource({});
                }}
              >
                Apparatuur toevoegen
              </Button>
            </div>
          </div>
        </div>
      </div>
      <table className="table table-sm text-nowrap">
        <thead>
          <tr>
            <th>Nummer</th>
            <th>Naam</th>
            <th>Omschrijving</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {resources.map((record, index) => {
            return (
              <tr key={record.id}>
                <td>{record.code}</td>
                <td>{record.name}</td>
                <td>{record.description}</td>
                <td>
                  <button
                    type="button"
                    title="Aanpassen"
                    className="btn btn-link p-0  mr-3"
                    onClick={() => {
                      setShowModal(true);
                      setSelectedResource(record);
                    }}
                  >
                    <i className="fas fa-pen"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {modal}
    </div>
  );
};

export default ResourcesSettings;
